(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["events-calendar"] && !Shopify.designMode) return;
  try {
    
  const initializeEventsCarousels = (scope = document) => scope.querySelectorAll('[data-events-carousel]').forEach((carousel) => {
    if (carousel.dataset.eventsReady === 'true') return;
    carousel.dataset.eventsReady = 'true';

    const track = carousel.querySelector('[data-events-track]');
    const previous = carousel.querySelector('[data-events-previous]');
    const next = carousel.querySelector('[data-events-next]');
    if (!track || !previous || !next) return;

    const move = (direction) => {
      const card = track.querySelector('.event-row');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(track).gap) || 0;
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior });
    };

    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
  });

  initializeEventsCarousels();
  document.addEventListener('shopify:section:load', (event) => initializeEventsCarousels(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-gallery"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('agricole-life-gallery')){
    customElements.define('agricole-life-gallery',class extends HTMLElement{
      connectedCallback(){
        if(this.controller)return;
        this.controller=new AbortController();
        this.track=this.querySelector('.flow-gallery__track');
        this.slides=[...this.track.querySelectorAll('[data-gallery-slide]')];
        this.count=this.slides.length;
        this.reduced=matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused=this.dataset.autoplay!=='true'||Boolean(window.Shopify?.designMode)||this.reduced.matches;
        this.visible=false;this.hovered=false;this.focused=false;this.index=0;
        if(this.count<2)return;
        for(const side of ['before','after']){
          const copies=this.slides.map(slide=>{
            const copy=slide.cloneNode(true);
            copy.setAttribute('data-gallery-clone','');
            copy.setAttribute('aria-hidden','true');
            copy.inert=true;
            copy.removeAttribute('data-gallery-slide');
            copy.removeAttribute('data-gallery-block');
            [copy,...copy.querySelectorAll('*')].forEach(node=>{
              node.removeAttribute('id');
              [...node.attributes].filter(attr=>attr.name.startsWith('data-shopify')).forEach(attr=>node.removeAttribute(attr.name));
            });
            copy.querySelectorAll('img').forEach(img=>{img.alt='';img.draggable=false;});
            return copy;
          });
          if(side==='before')this.track.prepend(...copies);else this.track.append(...copies);
        }
        this.slides.forEach(slide=>slide.querySelectorAll('img').forEach(img=>{img.draggable=false;}));
        const listen=(target,type,handler)=>target.addEventListener(type,handler,{signal:this.controller.signal});
        this.querySelectorAll('[data-gallery-nav]').forEach(button=>{
          button.hidden=false;
          listen(button,'click',()=>{this.pause();this.move(Number(button.dataset.galleryNav),true);});
        });
        this.toggle=this.querySelector('[data-gallery-toggle]');
        listen(this.toggle,'click',()=>{this.userPaused=!this.userPaused;this.syncPlayback();});
        listen(this.track,'scroll',()=>{
          clearTimeout(this.settleTimer);
          if(this.pointer)return;
          this.settleTimer=setTimeout(()=>this.settle(),160);
        });
        listen(this.track,'keydown',event=>{
          if(event.target!==this.track||!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
          event.preventDefault();this.pause();
          if(event.key==='Home'||event.key==='End')this.jump(event.key==='Home'?0:this.count-1,true);
          else this.move(event.key==='ArrowLeft'?-1:1,true);
        });
        listen(this.track,'wheel',event=>{if(Math.abs(event.deltaX)>Math.abs(event.deltaY))this.pause();});
        listen(this.track,'pointerdown',event=>{
          this.pause();
          if(event.pointerType!=='mouse'||event.button!==0)return;
          this.pointer={id:event.pointerId,x:event.clientX,left:this.track.scrollLeft};
          this.track.setPointerCapture(event.pointerId);
          this.track.dataset.dragging='';
          this.track.style.scrollSnapType='none';
        });
        listen(this.track,'pointermove',event=>{
          if(!this.pointer||event.pointerId!==this.pointer.id)return;
          this.track.scrollLeft=this.pointer.left+this.pointer.x-event.clientX;
        });
        const release=event=>{
          if(!this.pointer||event.pointerId!==this.pointer.id)return;
          this.pointer=null;delete this.track.dataset.dragging;this.track.style.scrollSnapType='';
          this.track.scrollTo({left:this.start+Math.round((this.track.scrollLeft-this.start)/this.step)*this.step,behavior:this.reduced.matches?'instant':'smooth'});
          clearTimeout(this.settleTimer);this.settleTimer=setTimeout(()=>this.settle(),180);
        };
        listen(this.track,'pointerup',release);listen(this.track,'pointercancel',release);
        listen(this,'mouseenter',()=>{if(matchMedia('(hover:hover)').matches){this.hovered=true;this.syncPlayback();}});
        listen(this,'mouseleave',()=>{this.hovered=false;this.syncPlayback();});
        listen(this,'focusin',()=>{this.focused=true;this.syncPlayback();});
        listen(this,'focusout',event=>{if(!this.contains(event.relatedTarget)){this.focused=false;this.syncPlayback();}});
        listen(document,'visibilitychange',()=>this.syncPlayback());
        listen(this.reduced,'change',()=>this.syncPlayback());
        listen(this,'shopify:block:select',event=>{
          const index=this.slides.findIndex(slide=>slide.dataset.galleryBlock===event.detail?.blockId||slide.contains(event.target));
          if(index>=0){this.pause();this.jump(index,false);}
        });
        this.resizeObserver=new ResizeObserver(()=>this.measure());
        this.resizeObserver.observe(this.track);
        this.visibilityObserver=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.syncPlayback();},{threshold:.25});
        this.visibilityObserver.observe(this);
        requestAnimationFrame(()=>{if(this.isConnected)this.measure();});
      }
      measure(){
        if(!this.track.clientWidth)return;
        const padding=parseFloat(getComputedStyle(this.track).paddingLeft)||0;
        this.step=this.slides[1].offsetLeft-this.slides[0].offsetLeft;
        this.start=this.slides[0].offsetLeft-padding;
        this.cycle=this.step*this.count;
        this.jump(this.index,false);
        this.syncPlayback();
      }
      instant(left){
        this.track.style.scrollSnapType='none';
        this.track.scrollTo({left,behavior:'instant'});
        cancelAnimationFrame(this.snapFrame);
        this.snapFrame=requestAnimationFrame(()=>{if(this.track&&!this.pointer)this.track.style.scrollSnapType='';});
      }
      jump(index,announce){
        this.index=index;
        if(this.start===undefined)return;
        this.instant(this.start+index*this.step);
        if(announce)this.announce();
      }
      move(direction,announce){
        if(!this.step)return;
        const current=Math.round((this.track.scrollLeft-this.start)/this.step);
        this.track.scrollTo({left:this.start+(current+direction)*this.step,behavior:this.reduced.matches?'instant':'smooth'});
        this.announceNext=announce;
      }
      settle(){
        if(this.pointer||!this.step)return;
        const offset=Math.round((this.track.scrollLeft-this.start)/this.step);
        this.index=((offset%this.count)+this.count)%this.count;
        if(offset<0||offset>=this.count)this.instant(this.start+this.index*this.step);
        if(this.announceNext){this.announce();this.announceNext=false;}
      }
      announce(){this.querySelector('[data-gallery-status]').textContent=this.slides[this.index].getAttribute('aria-label');}
      pause(){this.userPaused=true;this.syncPlayback();}
      syncPlayback(){
        clearTimeout(this.playTimer);
        if(!this.toggle)return;
        this.toggle.hidden=this.reduced.matches;
        this.querySelector('.flow-gallery__playback').hidden=this.reduced.matches;
        const label=this.userPaused?this.dataset.playLabel:this.dataset.pauseLabel;
        this.toggle.querySelector('[data-gallery-toggle-label]').textContent=label;
        this.toggle.querySelector('[data-gallery-toggle-icon]').textContent=this.userPaused?'▶':'Ⅱ';
        this.toggle.setAttribute('aria-label',label);
        if(!this.userPaused&&this.visible&&!this.hovered&&!this.focused&&!document.hidden&&!this.reduced.matches&&!window.Shopify?.designMode){
          this.playTimer=setTimeout(()=>{this.move(1,false);this.syncPlayback();},Math.max(3000,Number(this.dataset.interval)*1000||5000));
        }
      }
      disconnectedCallback(){
        this.controller?.abort();this.controller=null;
        clearTimeout(this.playTimer);clearTimeout(this.settleTimer);cancelAnimationFrame(this.snapFrame);
        this.resizeObserver?.disconnect();this.visibilityObserver?.disconnect();
        this.querySelectorAll('[data-gallery-clone]').forEach(node=>node.remove());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-signals"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeCarousel = (carousel) => {
      if (carousel.dataset.initialized === 'true') return;

      const viewport = carousel.querySelector('[data-review-viewport]');
      const track = carousel.querySelector('[data-review-track]');
      const previousButton = carousel.querySelector('[data-review-prev]');
      const nextButton = carousel.querySelector('[data-review-next]');
      const originalCards = [...track.querySelectorAll('[data-review-card]')];
      if (!viewport || !track || originalCards.length === 0) return;

      carousel.dataset.initialized = 'true';
      const cloneCount = Math.min(4, originalCards.length);
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const autoplayDelay = Number(carousel.dataset.autoplaySpeed) || 5000;
      let autoplayTimer;
      let scrollTimer;
      let resizeTimer;
      let isHovered = false;
      let isFocused = false;
      let isVisible = true;

      const prepareClone = (card) => {
        const clone = card.cloneNode(true);
        clone.removeAttribute('data-shopify-editor-block');
        clone.setAttribute('aria-hidden', 'true');
        clone.dataset.reviewClone = 'true';
        clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((element) => {
          element.setAttribute('tabindex', '-1');
        });
        return clone;
      };

      originalCards.slice(-cloneCount).reverse().forEach((card) => track.prepend(prepareClone(card)));
      originalCards.slice(0, cloneCount).forEach((card) => track.append(prepareClone(card)));

      const allCards = () => [...track.querySelectorAll('[data-review-card]')];
      const stepSize = () => {
        const first = allCards()[0];
        const styles = window.getComputedStyle(track);
        return first.getBoundingClientRect().width + (parseFloat(styles.columnGap || styles.gap) || 0);
      };
      const loopStart = () => cloneCount * stepSize();
      const loopWidth = () => originalCards.length * stepSize();

      const updateNeighbors = () => {
        const viewportBounds = viewport.getBoundingClientRect();
        const peek = parseFloat(window.getComputedStyle(carousel).getPropertyValue('--review-peek')) || 0;
        allCards().forEach((card) => {
          const bounds = card.getBoundingClientRect();
          const atLeftEdge = bounds.right > viewportBounds.left && bounds.left < viewportBounds.left + peek;
          const atRightEdge = bounds.left < viewportBounds.right && bounds.right > viewportBounds.right - peek;
          card.classList.toggle('is-neighbor', atLeftEdge || atRightEdge);
        });
      };

      const normalizeLoop = () => {
        const start = loopStart();
        const width = loopWidth();
        const step = stepSize();
        if (viewport.scrollLeft < start - (step * .5)) {
          viewport.scrollLeft += width;
        } else if (viewport.scrollLeft >= start + width - (step * .5)) {
          viewport.scrollLeft -= width;
        }
        updateNeighbors();
      };

      const move = (direction, behavior = 'smooth') => {
        viewport.scrollTo({ left: viewport.scrollLeft + (stepSize() * direction), behavior });
      };

      const stopAutoplay = () => window.clearInterval(autoplayTimer);
      const startAutoplay = () => {
        stopAutoplay();
        if (
          carousel.dataset.autoplay !== 'true' ||
          reducedMotion.matches ||
          document.hidden ||
          isHovered ||
          isFocused ||
          !isVisible ||
          originalCards.length < 2
        ) return;
        autoplayTimer = window.setInterval(() => move(1), autoplayDelay);
      };

      viewport.scrollLeft = loopStart();
      window.requestAnimationFrame(updateNeighbors);

      viewport.addEventListener('scroll', () => {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(normalizeLoop, 120);
        updateNeighbors();
      }, { passive: true });

      previousButton?.addEventListener('click', () => {
        move(-1);
        startAutoplay();
      });
      nextButton?.addEventListener('click', () => {
        move(1);
        startAutoplay();
      });
      carousel.addEventListener('mouseenter', () => {
        isHovered = true;
        stopAutoplay();
      });
      carousel.addEventListener('mouseleave', () => {
        isHovered = false;
        startAutoplay();
      });
      carousel.addEventListener('focusin', () => {
        isFocused = true;
        stopAutoplay();
      });
      carousel.addEventListener('focusout', (event) => {
        if (carousel.contains(event.relatedTarget)) return;
        isFocused = false;
        startAutoplay();
      });
      reducedMotion.addEventListener('change', startAutoplay);
      document.addEventListener('visibilitychange', startAutoplay);

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          isVisible = entries[0]?.isIntersecting ?? true;
          startAutoplay();
        }, { threshold: .15 });
        observer.observe(carousel);
      }

      window.addEventListener('resize', () => {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(() => {
          const step = stepSize();
          const currentIndex = Math.round((viewport.scrollLeft - loopStart()) / step);
          const normalizedIndex = ((currentIndex % originalCards.length) + originalCards.length) % originalCards.length;
          viewport.scrollLeft = loopStart() + (normalizedIndex * step);
          updateNeighbors();
        }, 150);
      });

      startAutoplay();
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-review-carousel]').forEach(initializeCarousel);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
